<template>
    <div id="evolt-display">
        <div v-if="biometrics">
            <evolt-graph :target="'weight_target'" :label="'WEIGHT'" :value="biometrics.weight_result" :starting="starting.weight_result" :unit="'kg'" :colour="'#0096BF'"></evolt-graph>
            <evolt-graph :target="'lbm_target'" :label="'LBM'" :value="biometrics.lean_body_mass_result" :starting="starting.lean_body_mass_result" :unit="'kg'" :colour="'#D74444'"></evolt-graph>
            <evolt-graph :target="'body_fat_target'" :label="'BODY FAT'" :value="biometrics.body_fat_percentage" :starting="starting.body_fat_percentage" :unit="'%'" :colour="'#ECB30A'"></evolt-graph>
            <evolt-graph :target="'vfl_target'" :label="'VFL'" :value="biometrics.visceral_fat_level" :starting="starting.visceral_fat_level" :colour="'#56804F'"></evolt-graph>
            <v-overlay
                :absolute="true"
                :value="noData"
                :light="true"
                :dark="false"
                opacity=".2"
                z-index="999999"
            >
                <v-card
                    elevation="2"
                    outlined
                    tile
                    class="ma-5"
                >
                    <v-card-text class="overlay-text"><p>Hmmm. We can't find any Evolt scan data linked to your account.</p><p>Make sure you have done your Evolt body scan to be eligible for judging.</p></v-card-text>
                </v-card>
            </v-overlay>
        </div>
    </div>
</template>

<script>
    import EvoltGraph from "./EvoltGraph";
    import {mapState} from "vuex";
    export default {
        name: "EvoltDisplay",
        components: {
            EvoltGraph,
        },
        computed: {
            noData: {
                get () {
                    return this.evolt_data && !this.evolt_data[0].id
                }
            },
            showScan () {
                return !this.user.hideScan && this.evolt_data && this.evolt_data !== 'not found'
            },
            ...mapState({
                user: state => state.auth.user,
                evolt_data: state => state.data.evolt_data,
                starting (state) { return this.biometrics_count > 0 ? state.data.evolt_data[state.data.evolt_data.length - 1] : null },
                biometrics (state) { return this.biometrics_count > 0 ? state.data.evolt_data[0] : null },
                biometrics_count: state => state.data.evolt_data ? state.data.evolt_data.length : 0
            })
        }
    }
</script>

<style lang="scss">

</style>
